// common type
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_LOGO_URL = 'SET_LOGO_URL'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_ASSOCIATION = 'ASSOCIATION'
export const SET_PRE_ANSWERLIST = 'SET_PRE_ANSWERLIST'